module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/new/store_images/3_7863f7b5c430af5b4fc4f2652e659e1f.png";